import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  @Input() page = 1;
  @Input() total = 0;
  @Input() pageSize = 15;
  @Input() showInfo = false;
  @Input() showPageSize = false;
  @Input() itemLabel = '';
  @Input() pageSizeOptions: number[] = [15, 25, 50, 100];
  @Input() mode: 'full' | 'simple' = 'full';
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  get totalPages(): number {
    return Math.ceil(this.total / this.pageSize);
  }

  get showingFrom(): number {
    if (this.total === 0) return 0;
    return (this.page - 1) * this.pageSize + 1;
  }

  get showingTo(): number {
    return Math.min(this.page * this.pageSize, this.total);
  }

  goTo(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.page) return;
    this.pageChange.emit(page);
  }

  first(): void { this.goTo(1); }
  prev(): void { this.goTo(this.page - 1); }
  next(): void { this.goTo(this.page + 1); }
  last(): void { this.goTo(this.totalPages); }

  onPageSizeChange(size: number): void {
    if (!size || size < 1) return;
    this.pageSizeChange.emit(size);
  }
}
